import { defineMessages } from 'react-intl';

export const subscribeSheetMessages = defineMessages({
  sheetTitle: {
    id: 'forms.newsletter.subscribe.sheet.sheettitle',
    defaultMessage: 'Psst, 15% Rabatt warten auf dich!',
  },
  formHeadline: {
    id: 'forms.newsletter.subscribe.sheet.formheadline',
    defaultMessage: 'Unseren Newsletter abonnieren & Rabatt als Dankeschön erhalten',
  },
  formDescription: {
    id: 'forms.newsletter.subscribe.sheet.formdesription',
    defaultMessage:
      "Ich möchte in Zukunft mit dem kostenlosen Newsletter von MARKE über alle Angebote und Aktionen informiert werden. Ich weiß, dass ich den Newsletter jederzeit wieder <a href='#'>hier abbestellen</a> kann.",
  },
  button: {
    id: 'forms.newsletter.subscribe.sheet.submitbutton',
    defaultMessage: 'Anmelden & 15% Rabatt erhalten',
  },
  buttonMobile: {
    id: 'forms.newsletter.subscribe.sheet.submitbuttonmobile',
    defaultMessage: 'anmelden',
  },
  emailPlaceholder: {
    id: 'forms.newsletter.subscribe.sheet.emailplaceholder',
    defaultMessage: 'Deine E-Mail Adresse eintragen',
  },
  termsHeadline: {
    id: 'forms.newsletter.subscribe.sheet.termsheadline',
    defaultMessage: 'Gutscheinbedingungen',
  },
  termsContent: {
    id: 'forms.newsletter.subscribe.sheet.termscontent',
    defaultMessage: '',
  },
  successHeadline: {
    id: 'forms.newsletter.subscribe.sheet.successheadline',
    defaultMessage: 'Fast geschafft …',
  },
  successContent: {
    id: 'forms.newsletter.subscribe.sheet.successcontent',
    defaultMessage:
      'Wir haben dir gerade eine E-Mail geschickt. <b>Bitte bestätige deine Anmeldung zum Newsletter über den Button in dieser E-Mail</b> – erst danach ist deine Anmeldung abgeschlossen. Deinen Willkommensrabatt senden wir dir anschließend in einer seperaten E-Mail zu.',
  },
  doiText: {
    id: 'forms.newsletter.subscribe.sheet.doitext',
    defaultMessage:
      'Du hast unseren Newsletter noch nicht erhalten? Dann fehlt uns Deine Bestätigung für {email}.',
  },
  doiLink: {
    id: 'forms.newsletter.subscribe.sheet.doilink',
    defaultMessage: 'Jetzt neue Bestätigungsmail anfordern.',
  },
});
